import { AxiosError } from 'axios';
import { UseMutationOptions } from 'react-query';

import useAPIMutation from '../api/useAPIMutation';
import { SyncQuestionActionCollectionInputData } from '../types';

const useAdditionalQuestionsMutation = (
  options?: Omit<
    UseMutationOptions<
      void,
      AxiosError<unknown, unknown>,
      SyncQuestionActionCollectionInputData,
      unknown
    >,
    'mutationFn'
  >
) => {
  return useAPIMutation(async (data, api) => {
    await api.post('/questions-actions/sync/', data);
  }, options);
};

export default useAdditionalQuestionsMutation;
